import React from 'react';
import { Box, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { getConditionText } from 'utils/helpers/tunnels';
import { texts } from 'utils/languages/fr';
import { HelpCircleOutline } from 'mdi-material-ui';
import PropTypes from 'prop-types';

const actionSectionSx = { ml: 2, mb: 1 };

const actionItemSx = alertType => ({
    padding: 1,
    mb: 1,
    borderLeft: `3px solid ${
        alertType === 'ok' ? 'green' : alertType === 'warning' ? 'orange' : 'red'
    }`,
});

const compactListItemSx = {
    pt: theme => theme.spacing(0.5),
    pb: theme => theme.spacing(0.5),
    pl: theme => theme.spacing(1),
    pr: theme => theme.spacing(1),
};
const compactListItemIconSx = { minWidth: theme => theme.spacing(4) };

const actionConditionSx = {
    display: 'flex',
    alignItems: 'center',
    gap: theme => theme.spacing(1),
};

const Actions = ({ tunnel }) => {
    return (
        <Box sx={actionSectionSx}>
            {tunnel.actions.map((action, actionIndex) => (
                <Box key={actionIndex} sx={actionItemSx(action.alertType)}>
                    <Typography variant="subtitle1">
                        {texts.ACTION_NAME}: {action.name}
                    </Typography>
                    <Box sx={{ marginLeft: 2, marginTop: 0.5, color: 'text.secondary' }}>
                        <Typography variant="body2">
                            {texts.TYPE}:{' '}
                            {action.alertType === 'critical'
                                ? texts.ALERTS.CRITICAL_ALERT
                                : action.alertType === 'warning'
                                ? texts.ALERTS.WARNING_ALERT
                                : action.alertMessage || texts.ALERTS.NO_ALERT_TEXT}
                        </Typography>
                        <Typography variant="body2">
                            {texts.ALERTS.ALERT_TEXT}:{' '}
                            {action.alertMessage || texts.ALERTS.NO_ALERT_TEXT}
                        </Typography>
                        {action.actionConditions?.map((condition, condIndex) => (
                            <Box key={condIndex} sx={actionConditionSx}>
                                <Typography variant="body2">
                                    {texts.ALERTS.ALERT_CONDITION}: {getConditionText(condition)}
                                </Typography>
                            </Box>
                        ))}
                        <Typography variant="body2">
                            {texts.ALERTS.WRONG_CHARACTER}:{' '}
                            {action.wrongCharacter ? texts.OUI : texts.NON}
                        </Typography>
                        {action.questions && action.questions.length > 0 && (
                            <List component="div">
                                {action.questions.map((question, questionIndex) => (
                                    <ListItem key={questionIndex} sx={compactListItemSx}>
                                        <ListItemIcon sx={compactListItemIconSx}>
                                            <HelpCircleOutline color="info" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={
                                                <Typography variant={'body2'}>
                                                    {question.title}
                                                </Typography>
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        )}
                    </Box>
                </Box>
            ))}
        </Box>
    );
};

Actions.propTypes = {
    tunnel: PropTypes.shape({
        actions: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
                alertType: PropTypes.string,
                alertMessage: PropTypes.string,
                wrongCharacter: PropTypes.bool,
                questions: PropTypes.arrayOf(
                    PropTypes.shape({
                        title: PropTypes.string,
                    })
                ),
                actionConditions: PropTypes.array,
            })
        ).isRequired,
    }).isRequired,
};

export default Actions;
